module.exports = __webpack_public_path__ + "img/4.230f7b07.jpg";